import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { catchError, EMPTY, map, Observable, tap } from 'rxjs';
import { ApiService } from '../services/api.service';
import { IUsecaseDetail } from '../models/usecase-details.model';
import { UtilityService } from '../services/utility.service';
import { webRedirectionUrl } from '../constants/web-redirection-url';
import { NavigationService } from '../services/navigation.service';
import { AnalyticsService } from '../services/analytics.service';

export const usecaseDetailsResolver: ResolveFn<Observable<IUsecaseDetail>> = (
  route: ActivatedRouteSnapshot,
) => {
  const slug: string = route.params['slug'].split('.html')[0];
  const apiService = inject(ApiService);
  const utilityService = inject(UtilityService);
    const navigationService = inject(NavigationService)
  const analyticsService = inject(AnalyticsService);

  if (utilityService.isUserLoggedIn()) {
    const url = `${webRedirectionUrl.usecaseDetails}${slug}`;
    utilityService.saveUrlandRedirect(url);
    return EMPTY;
  } else {
    return apiService.fetchUsecasesDetails(slug).pipe(
      map((resp) => {
        if (resp.header.success && resp.data) {
          return resp.data;
        }

        throw new Error(resp.header.msg);
      }),
      tap((data) => {
        analyticsService.logEvent('usecase_view', {
          id: data?.id,
          name: data?.name,
          slug: data?.slug,
        });
      }),
      catchError((error) => {
        navigationService.handleResolverError(error)
        return EMPTY;
      }),
    );
  }
};
